export default __webpack_public_path__ + "static/media/redCircle.cefa6550.png";